<div class="row">
  <div class="col-md-6 col-lg-6 large-screen mx-auto">
    <form novalidate [formGroup]="profileSwitchingComponentForm" class="loginForm">
      <div class="row">
        <div class="col-md-12 text-center">
          <p class="page-title mt-3">Account Selection</p>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <ng-table
            [rows]="profiles"
            [columns]="columns"
            [showFilterRow]="false"
            (cellClicked)="selectProfile($event)">
          </ng-table>
        </div>
      </div>
    </form>
  </div>
</div>